import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MessageShowPage } from './message-show';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		MessageShowPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(MessageShowPage),
	],
})
export class MessageShowPageModule {}



// WEBPACK FOOTER //
// ./src/pages/message-show/message-show.module.ts